import { Checkbox, type CheckboxShape } from '@frekuent/orbit/components';
import { useSelect } from '../hooks/useCoreContext';
import { useMemo } from 'react';

const SelectAllRow = ({
	index,
	label,
	checkBoxShape = 'round',
	scope = 'global',
}: {
	index: number;
	label: React.ReactNode;
	checkBoxShape?: CheckboxShape;
	scope: 'global' | 'visible';
}) => {
	const {
		allVisibleSelected,
		toggleSelectAllGlobal,
		toggleSelectAllVisible,
		highlightedIndex,
		getItemProps,
		visibleOptions,
		isSelected,
		listRef,
		setHighlightedIndex,
		isAllActive,
		interactionModeRef,
	} = useSelect();
	const highlighted = highlightedIndex === index;

	const visibleCount = visibleOptions.length;
	const visibleSelectedCount = useMemo(
		() => visibleOptions.reduce((acc, o) => acc + (isSelected(o.value) ? 1 : 0), 0),
		[visibleOptions, isSelected],
	);

	let checked = false;
	let indeterminate = false;
	let disabled = false;
	let onClick: any;

	if (scope === 'global') {
		checked = isAllActive;
		indeterminate = !checked && visibleSelectedCount > 0;
		onClick = (e: any) => {
			e.preventDefault();
			toggleSelectAllGlobal();
		};
	} else {
		checked = isAllActive || (visibleCount > 0 && visibleSelectedCount === visibleCount);
		indeterminate = !isAllActive && visibleSelectedCount > 0 && visibleSelectedCount < visibleCount;
		disabled = isAllActive;
		onClick = (e: any) => {
			e.preventDefault();
			if (!disabled) toggleSelectAllVisible();
		};
	}

	return (
		<li
			ref={(node) => {
				listRef.current[index] = node;
			}}
			tabIndex={highlighted ? 0 : -1}
			aria-selected={allVisibleSelected}
			{...getItemProps()}
			onPointerEnter={(event) => {
				if (event.pointerType !== 'mouse') return;
				interactionModeRef.current = 'pointer';
				setHighlightedIndex(index);
			}}
			onClick={onClick}
			className={`px-4 py-2 cursor-pointer rounded 
                ${highlighted ? 'bg-secondary-ultra-light' : 'hover:bg-secondary-ultra-light'}
                flex gap-2 hover:bg-secondary-ultra-light  ${disabled ? 'opacity-60 cursor-not-allowed' : ''}
				
                `}
		>
			<Checkbox
				isChecked={checked}
				shape={checkBoxShape}
				highlightIndex={highlighted}
				isIndeterminate={indeterminate}
				disabled={disabled}
			/>

			{label}
		</li>
	);
};

export default SelectAllRow;
